import { connect } from 'react-redux'
import Select from 'react-select'
import at from 'lodash/at'
import map from 'lodash/map'
import { setFiltersLoading, setCalendarFiltersForService } from '../../actions/calendar-filters'

const mapStateToProps = (state, ownProps) => {
  const locationId = ownProps.locationId

  if (!locationId) return { options: [] }

  const services = at(state.services, state.services.ids || [])

  const options = services.map((service) => (
    {
      value: service.id,
      label: service.name,
    }
  ))

  const { isLoading = false } = state.calendarFilters

  return {
    options,
    isLoading,
    multi: true,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChange(items) {
      const serviceIds = items ? map(items, 'value') : null

      dispatch(setFiltersLoading(true))
        .then(() => dispatch(setCalendarFiltersForService(serviceIds)))
        .then(() => ownProps.onChange(items))
        .then(() => dispatch(setFiltersLoading(false)))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Select)




// WEBPACK FOOTER //
// ./src/containers/calendar/select-service-container.js